import React from 'react'
import ContentLoader from 'react-content-loader'
import {
  DetailCardWapper,
  HeaderContainer,
  HeaderWapper,
  CardTabContainer,
} from 'components/DetailCard'
import {
  BaseInfoWapper,
  ImageWapper,
  RightBaseInfo,
} from 'components/SkuDetailV2/BaseInfo'
import styled from 'styled-components'
import { useUserAgentStore } from 'store/userAgentStore'
import { mobileSize } from 'theme'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const LoaderWapper = styled(DetailCardWapper)`
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`

const Line = styled.div`
  width: 100%;
  height: 0;
  border-top: 1px solid ${(p) => p.theme.color.grey80};
  margin-bottom: 16px;
  @media ${mobileSize} {
    margin-top: 40px;
  }
`
const DetailLoader = ({ showHeader }) => {
  const userAgentStore = useUserAgentStore()
  const isMobile = userAgentStore.isMoblie()
  const theme = useTheme()
  const matchesSm = useMediaQuery(theme.breakpoints.down('xs'))
  const isMobileBreakpoint = isMobile || matchesSm
  return (
    <LoaderWapper>
      {showHeader && <CardHeader />}
      <BaseInfoWapper>
        <ImageWapper>
          <ContentLoader
            height={509}
            width={910}
            speed={2}
            viewBox="0 0 910 509"
            backgroundColor="#ecf0f3"
            foregroundColor="#f1f6fb"
          >
            <rect x="0" y="0" rx="4" ry="4" width="910" height="509" />
          </ContentLoader>
        </ImageWapper>
        <RightBaseInfo>
          <ContentLoader
            height={72}
            width={560}
            speed={2}
            viewBox="0 0 560 72"
            backgroundColor="#ecf0f3"
            foregroundColor="#f1f6fb"
          >
            <rect x="0" y="0" rx="4" ry="4" width="424" height="32" />
            <rect x="0" y="48" rx="4" ry="4" width="188" height="24" />
          </ContentLoader>
          {!isMobileBreakpoint && (
            <ContentLoader
              height={80}
              width={660}
              speed={2}
              viewBox="0 0 660 80"
              backgroundColor="#d5e1ff"
              foregroundColor="#f1f6fb"
            >
              <rect x="0" y="16" rx="4" ry="4" width="160" height="48" />
            </ContentLoader>
          )}
        </RightBaseInfo>
      </BaseInfoWapper>
      <CardTabContainer>
        <Line />
        <CardTabLoader isMobileBreakpoint={isMobileBreakpoint} />
      </CardTabContainer>
    </LoaderWapper>
  )
}
const CardHeader = () => {
  return (
    <HeaderContainer>
      <HeaderWapper>
        <ContentLoader
          height={48}
          width={900}
          speed={2}
          viewBox="0 0 900 48"
          backgroundColor="#ecf0f3"
          foregroundColor="#f1f6fb"
        >
          <circle cx="24" cy="24" r="24" />
          <rect x="74" y="12" rx="4" ry="4" width="376" height="28" />
        </ContentLoader>
      </HeaderWapper>
    </HeaderContainer>
  )
}
const CardTabLoader = ({ isMobileBreakpoint }) => {
  if (isMobileBreakpoint) {
    return <MobilTabLoader />
  }
  return <DefaultTabLoader />
}

const DefaultTabLoader = () => {
  return (
    <ContentLoader
      height={120}
      width={660}
      speed={2}
      viewBox="0 0 660 120"
      backgroundColor="#ecf0f3"
      foregroundColor="#f1f6fb"
    >
      <rect x="8" y="0" rx="4" ry="4" width="80" height="24" />
      <rect x="188" y="0" rx="4" ry="4" width="179" height="24" />
      <rect x="8" y="48" rx="4" ry="4" width="80" height="24" />
      <rect x="188" y="48" rx="4" ry="4" width="179" height="24" />
      <rect x="8" y="96" rx="4" ry="4" width="80" height="24" />
      <rect x="188" y="96" rx="4" ry="4" width="376" height="24" />
    </ContentLoader>
  )
}

const MobilTabLoader = () => {
  return (
    <ContentLoader
      height={120}
      width={560}
      speed={2}
      viewBox="0 0 560 120"
      backgroundColor="#ecf0f3"
      foregroundColor="#f1f6fb"
    >
      <rect x="8" y="0" rx="4" ry="4" width="80" height="24" />
      <rect x="8" y="32" rx="4" ry="4" width="179" height="24" />
      <rect x="8" y="64" rx="4" ry="4" width="80" height="24" />
      <rect x="8" y="96" rx="4" ry="4" width="179" height="24" />
    </ContentLoader>
  )
}

export default DetailLoader
